import React from 'react';
export function Footer() {
  return <footer className="bg-violet text-white pt-8 pb-12 border-t border-white/10" data-id="element-68">
      <div className="max-w-md mx-auto px-4 text-center" data-id="element-69">
        <div className="font-bold text-xl mb-4" data-id="element-70">🎵 Flauta Master Class™</div>
        <p className="text-sm text-white/80 leading-relaxed mb-6" data-id="element-71">
          El repertorio N°1 para docentes de música de primaria que quieren dar
          clase organizados, sin improvisar y con el repertorio siempre a mano.
        </p>

        <div className="flex justify-center gap-4 text-sm mb-8 text-turquoise" data-id="element-72">
          <a href="#" className="hover:text-white transition-colors" data-id="element-73">
            📧 Email
          </a>
          <span data-id="element-74">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-75">
            📱 Instagram
          </a>
          <span data-id="element-76">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-77">
            🌐 Sitio
          </a>
        </div>

        <div className="text-xs text-white/50 mb-4" data-id="element-78">
          © Flauta Master Class™ 2026 — Todos los derechos reservados.
        </div>

        <div className="text-sm font-medium italic text-white/70" data-id="element-79">
          🎵 "Menos improvisación, más clase resuelta."
        </div>
      </div>
    </footer>;
}